<app-card class="flex-basis-100 mb-12">
  <div cardTitle i18n>Demande de modifications</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows">
      <div class="card__row">
        <span class="card__label" i18n>Police d'origine</span>
        <div class="d-flex gap-2 flex-column card__value">
          <a [routerLink]="['/proposal/view', metadata.originalProposalId]" i18n
            >Voir la police d'origine</a
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.originalProposalId &&
              originalMetadata.originalProposalId !==
                metadata.originalProposalId
            "
          >
            <a
              [routerLink]="[
                '/proposal/view',
                originalMetadata.originalProposalId,
              ]"
              i18n
              >Voir l'ancienne police</a
            >
          </span>
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.endDate || originalMetadata?.endDate"
      >
        <span class="card__label" i18n>Date de fin</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.endDate !== metadata.endDate,
            }"
            >{{ metadata.endDate | customDate }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.endDate &&
              originalMetadata.endDate !== metadata.endDate
            "
            >{{ originalMetadata.endDate | customDate }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.otherDetails || originalMetadata?.otherDetails"
      >
        <span class="card__label" i18n>Détails supplémentaires</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.otherDetails !== metadata.otherDetails,
            }"
            >{{ metadata.otherDetails }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.otherDetails &&
              originalMetadata.otherDetails !== metadata.otherDetails
            "
            >{{ originalMetadata.otherDetails }}</span
          >
        </div>
      </div>
    </div>
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="metadata?.insuranceType || originalMetadata?.insuranceType"
      >
        <span class="card__label" i18n>Type d'assurance d'origine</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.insuranceType !== metadata.insuranceType,
            }"
            >{{ getInsuranceTypeLabel(metadata.insuranceType) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.insuranceType &&
              originalMetadata.insuranceType !== metadata.insuranceType
            "
            >{{ getInsuranceTypeLabel(originalMetadata.insuranceType) }}</span
          >
        </div>
      </div>

      <div
        class="card__row"
        *ngIf="metadata?.periodicity || originalMetadata?.periodicity"
      >
        <span class="card__label" i18n>Périodicité</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.periodicity !== metadata.periodicity,
            }"
            >{{ getPeriodicityLabel(metadata.periodicity) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.periodicity &&
              originalMetadata.periodicity !== metadata.periodicity
            "
            >{{ getPeriodicityLabel(originalMetadata.periodicity) }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>
